const GARConnection = () => {
  return (
    <div className=" bg-transparent min-h-screen flex items-center justify-center p-6">
      {/* Card principale */}
      <div className="bg-white rounded-3xl shadow-2xl p-12 w-full max-w-md mx-auto relative">
   
        {/* Logo GAR */}
        <div className="flex justify-center mb-8">
          <div className="w-20 h-20 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center shadow-lg">
            <span className="text-white text-2xl font-bold">GAR</span>
          </div>
        </div>
        
        {/* Titre principal */}
        <h1 className="text-slate-800 text-2xl font-bold text-center mb-2 leading-tight">
          Gestionnaire d'Accès aux Ressources
        </h1>
        
        {/* Sous-titre */}
        <p className="text-slate-500 text-center mb-10 font-medium">
          Ministère de l'Éducation Nationale
        </p>
        
        {/* Statut de connexion */}
        <p className="text-blue-600 text-lg font-semibold text-center mb-6">
          Connexion avec le GAR en cours...
        </p>
        
        {/* Spinner */}
        <div className="flex justify-center mb-4">
          <div className="w-12 h-12 border-4 border-slate-200 border-l-blue-600 rounded-full animate-spin"></div>
        </div>
        
        {/* Texte de chargement */}
        <p className="text-slate-500 text-center text-sm font-medium">
          Chargement des ressources...
        </p>
      </div>
    </div>
  );
};

export default GARConnection;